<article
    class="flex flex-col p-4 rounded-2xl bg-white shadow-sm gap-3 border border-solid max-w-full min-w-[19rem] hover:shadow-md transition-all h-full">
    <header class="dark-overlay card-header bg-blue  rounded-xl max-w-full px-4 py-5  relative">
        <img [ngSrc]="dataSource.ImageHeader" height="70" width="422" [alt]="dataSource.Title"
        class="w-full absolute top-0 right-0 rounded-xl h-full object-cover">
        <div class="flex items-center justify-between">
            <h3 class="text-white text-heading3 text-xl whitespace-nowrap">{{ dataSource.Title }}</h3>
            <span
                class="bg-red-400 border border-solid z-[1] border-white px-3 rounded-lg relative text-white text-sm whitespace-nowrap">تا
                {{ dataSource.Discount }}% تخفیف</span>

        </div>
    </header>

    <div class="flex flex-col items-stretch flex-grow">
        <a *ngFor="let eachHotel of dataSource.Infos" [href]="eachHotel.Url" (click)="goToHotel($event,eachHotel.Url)"
            class="border-bottom py-2 gap-2 hover:!border-blue transition-all flex-grow">
            <div class="flex items-center justify-between">
                <h4 class="text-black text-base">{{ eachHotel.Title }}</h4>
                <span role="hotel-rating" class="flex items-center justify-center grade h-8 w-8">{{ eachHotel.AvgRate
                    }}</span>
            </div>
            <div class="flex items-center justify-between">
                <iho-stars-rate *ngIf="dataSource?.Star?.GradeId !== 0" [rating]="eachHotel?.Star?.StarClassName | extractGrade"></iho-stars-rate>
                <p class="flex items-center" *ngIf="eachHotel?.Price">
                    <span class="text-black-500 text-xl font-bold">{{ eachHotel.Price }}</span>
                    <span class="text-muted text-xs mx-1"> تومان </span>
                </p>
            </div>
        </a>
    </div>

    <a [href]="dataSource.Url" (click)="goToPlp($event)">
        <button mat-stroked-button color="primary" class="primary-border w-full !h-11">همه {{dataSource.Title}}</button>
    </a>
</article>
